
// JS
// ==================================================

jQuery(document).ready(function() {

  // Mobile Overlay

  jQuery('#toggle').click(function() {
   jQuery(this).toggleClass('active');
   jQuery('#overlay').toggleClass('open');
   jQuery('body').toggleClass('no-scroll');
  });

  // Company Carousel

  jQuery('.company-carousel').owlCarousel({
    loop:true,
    margin: 48,
    nav:true,
    autoHeight:true,
    autoplay: true,
    responsive:{
      0:{
        items:1
      },
      768:{
        items: 5
      }
    }
  
  });

  // Vacancies Carousel

  jQuery('.vacancies-carousel').owlCarousel({
    loop:true,
    margin: 48,
    nav:true,
    autoplay: true,
    responsive:{
      0:{
        items:1
      },
    }
        
  });

  // Google Map

  function initialise() {
      
    var myLatlng = new google.maps.LatLng(53.0907841, -2.4149577);

    var isDraggable = !('ontouchstart' in document.documentElement);

    var mapOptions = {
      draggable: isDraggable,
      zoom: 12,
      minZoom: 8,
      maxZoom: 16,
      zoomControl:true,
      zoomControlOptions: {
        style:google.maps.ZoomControlStyle.DEFAULT
      },
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      panControl:false,
      mapTypeControl:false,
      scaleControl:false,
      streetViewControl:false, 
      overviewMapControl:false,
      rotateControl:false,
      styles: [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ] 
      
    };

    var map = new google.maps.Map(document.getElementById('map'), mapOptions);
      
    var image = new google.maps.MarkerImage("http://chrysalisrail.com.gridhosted.co.uk/wp-content/themes/template/dist/images/map-marker.png", null, null, null, new google.maps.Size(127,88));
        
    var marker = new google.maps.Marker({
    
      position: myLatlng,
      icon:image,
      map: map
    
    });
      
    google.maps.event.addDomListener(window, 'resize', function() {

      setTimeout(function() {
        map.setCenter(myLatlng); 
      }, 100);

    });

  }

  google.maps.event.addDomListener(window, 'load', initialise);

  // Get in Touch Validation

  function validate_get_in_touch(){
    var error = {};
    error.error_messages = [];
    error.has_error = false;
    if (jQuery(".get-in-touch #name").val() == "") {
      jQuery(".get-in-touch #name").css({
        background: "#ff7100",
        color: "#ffffff",
      });
      error.has_error = true;
      error.error_messages.push('Please enter your full name');
    } else {
      jQuery(".get-in-touch #name").css({
        background: "#01609a",
        color: "#ffffff",
      });
    }  
    if (jQuery(".get-in-touch #email").val() == "") {
      jQuery(".get-in-touch #email").css({
        background: "#ff7100",
        color: "#ffffff"
      });
      error.has_error = true;
      error.error_messages.push('Please enter your email address');
    } else {
      jQuery(".get-in-touch #email").css({
        background: "#01609a",
        color: "#ffffff"
      });
    }
    if (jQuery(".get-in-touch #message").val() == "") {
      jQuery(".get-in-touch #message").css({
        background: "#ff7100",
        color: "#ffffff"
      });
      error.has_error = true;
      error.error_messages.push('Please enter your message');
    } else {
      jQuery(".get-in-touch #message").css({
        background: "#01609a",
        color: "#ffffff"
      });
    }

    return error;
  }

  jQuery('.get-in-touch.attempted-submit input').on('input',function(e){
    validate_get_in_touch();
  });

  jQuery(".get-in-touch").submit(function(e) {

    jQuery(this).addClass('attempted-submit');

    var validation = validate_get_in_touch();

    var error = validation.has_error;
    var error_messages = validation.error_messages;

      if (error === false) {
        e.preventDefault();
        
        jQuery.post( theme_url+"/enquiry.php", {
          'name' :jQuery('.get-in-touch #name').val(),
          'company' :jQuery('.get-in-touch #company').val(),
          'email' :jQuery('.get-in-touch #email').val(),
          'telephone' :jQuery('.get-in-touch #telephone').val(),
          'message': jQuery('.get-in-touch #message').val(),
          'url':jQuery('.get-in-touch .url').val()
        }).done(function( data ) {
          console.log(data);
          jQuery('.success').show();
          jQuery('.get-in-touch').slideUp();
        });

        return false;

      } else {

        jQuery('.get-in-touch .error-messages').html('');
        for (var i = 0; i < error_messages.length; i++) {
          jQuery('.get-in-touch .error-messages').append(error_messages[i]+'<br/>');
        }

        jQuery('.get-in-touch .error-messages').show();
        jQuery('.get-in-touch .error-messages').css({display: 'block'});
        e.preventDefault();

      }

    return false;
  
  });

  // Home Box Height
  // ==================================================

  const mq = window.matchMedia( "(min-width: 1024px)" );

  if (mq.matches) {
  
    var byRow = jQuery('body').hasClass('home');

    jQuery('.col').each(function() {
      jQuery(this).children('.box').matchHeight({
      });
      
    });

  }

  // Services Stacked Carousel

  var element1 = document.getElementById('cs-1'),
      element2 = document.getElementById('cs-2'),
      element3 = document.getElementById('cs-3');

  // var element = document.querySelector('.carousel-service');

  var slider1 = new Bee3D(element1, {
    effect: 'coverflow',
    listeners: {
      keys: true,
      touches: true
    },
  
    navigation: {
      enabled: true
    },

    loop: {
      enabled: true
    }
  
  });

  var slider2 = new Bee3D(element2, {
    effect: 'coverflow',
    listeners: {
      keys: true,
      touches: true
    },
  
    navigation: {
      enabled: true
    },

    loop: {
      enabled: true
    }
  
  });

  var slider3 = new Bee3D(element3, {
    effect: 'coverflow',
    listeners: {
      keys: true,
      touches: true
    },
  
    navigation: {
      enabled: true
    },

    loop: {
      enabled: true
    }
  
  });

});